import type { CatalogRide } from '@runkr/config/catalog'
import { assetUrl } from '../runnerPreview/previewLayout'
import { rideIcon } from './rideImages'
import styles from './rides.module.css'

/**
 * One ride in the Rides tab (PHASE3 T3.11): its icon, name, ability and one-line blurb. Tapping
 * equips it; the equipped one has the mint corner frame and says so. A locked ride (a price,
 * from T3.9) shows its price and cannot be equipped yet.
 */
export function RideCard({
  ride,
  equipped,
  owned,
  onPick,
}: {
  ride: CatalogRide
  equipped: boolean
  owned: boolean
  onPick: (id: CatalogRide['id']) => void
}) {
  const icon = rideIcon(ride.id)
  const state = equipped ? 'Equipped' : owned ? 'Equip' : `${ride.price} ${ride.currency}`
  return (
    <button
      type="button"
      class={`${styles.card} ${equipped ? styles.equipped : ''} ${owned ? '' : styles.locked}`}
      aria-pressed={equipped}
      aria-disabled={!owned}
      aria-label={`${ride.name}: ${ride.ability}. ${ride.blurb}`}
      data-ride={ride.id}
      onClick={() => owned && onPick(ride.id)}
    >
      <span class={styles.icon}>
        {icon ? (
          <img src={assetUrl(icon)} alt="" draggable={false} />
        ) : (
          <span class={styles.iconSoon}>{ride.name[0]}</span>
        )}
      </span>
      <span class={styles.text}>
        <span class={styles.name}>{ride.name}</span>
        <span class={styles.tags}>
          <span class={styles.ability}>{ride.ability}</span>
          <span class={`${styles.state} ${equipped ? styles.stateOn : ''}`}>{state}</span>
        </span>
      </span>
      <span class={styles.blurb}>{ride.blurb}</span>
    </button>
  )
}
